export default {
  data() {
    return {
      i: 0,
      page: 1,
      pages: 0,
      userInfo: {}, //
      navList: ['小姐姐', '小哥哥'],
      luckList: [], //原分类表
    }
  },
  created() {
    this.getVipList()
    if (localStorage.getItem('incredible-k')) {
      this.getUserInfo()
    }
  },
  methods: {
    changePage(e) {
      this.page = e
      this.getVipList()
    },
    //去vip详情
    goVipMessage(id) {
      if (this.userInfo.is_member == 1 || this.userInfo.is_member == 3) {
        this.$router.push({ path: '/vipMessage', query: { id } })
      } else {
        this.$router.push({ path: '/applyInitiation' })
      }
    },
    //申请入会
    goApply() {
      this.$router.push('/applyInitiation')
    },
    //切换状态
    changeI(index) {
      this.i = index
      this.page = 1
      this.pages = 0
      this.getVipList()
    },
    //获取缘分列表
    getVipList() {
      this.$axios
        .post('/api/index/luckList', {
          sex: Number(this.i) + 1,
          page: this.page,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.pages = res.data.data.last_page
            this.luckList = res.data.data.memberList
          } else {
            this.luckList = []
          }
        })
    },
    //获取个人信息
    getUserInfo() {
      this.$axios.post('/api/users/getUserInfo').then((res) => {
        if (res.data.code === 0) {
          this.userInfo = res.data.data
        }
      })
    },
  },
}
